import { useCallback, useState } from 'react';
import { crewService } from '../services';
import { Crew } from '../types/entities';

export const useCrews = (organizationId?: number) => {
  const [crews, setCrews] = useState<Crew[]>([]);

  const loadCrews = useCallback(async () => {
    if (!organizationId) return;

    try {
      const crewList =
        await crewService.getActiveByOrganization(organizationId);
      setCrews(crewList || []);
    } catch (error) {
      console.error('Error loading crews:', error);
      throw error;
    }
  }, [organizationId]);

  return {
    crews,
    setCrews,
    loadCrews,
  };
};
